import React from 'react';
import { useNavigate } from 'react-router-dom';

import useCurrentSerieResult from 'hooks/useCurrentSerieResult';
import { SERIES } from 'config/url';

import Button from 'components/Button';
import Spinner from 'components/Spinner';

const Result = ({score, max_score}) => {
  return (
    <>
    <h4 className="title is-4">{score} / {max_score}</h4>
    <p>Vous pouvez retrouver votre score et l'ensemble de vos réponses dans l'onglet Statisiques</p>
    </>
  )
}

const EndOfSerie = ({serieId}) => {
  const result = useCurrentSerieResult(serieId);
  const navigate = useNavigate();
  return (
    <div className="card mb-6">
      <div className='p-3 m-0 mb-3 has-background-primary-light'>
        <h3 className="title is-3 ">La série est terminée</h3>
      </div>
      <div className="card-content p-5">
        <div className="content">
        <h4 className="title is-4">Bravo vous avez terminé la série</h4>
        <h5 className="title is-5">Votre score est de :</h5>
        {result ?
          <Result {...result} />
          :
          <Spinner size="3x" />
        }
        <Button className="is-fullwidth is-primary my-4" onClick={() => navigate(SERIES)}>
          Retourner aux séries
        </Button>
        </div>
      </div>
    </div>
  )
}

export default EndOfSerie;